// PDP adapter for the collect lead-time engine: derives the Collectable item
// view, lead times, and storefront stock from the product store + site
// preferences, so every PDP surface resolves scenarios from the same facts.
// Stock stays per surface — callers pass their own store's stock line.
export const useCollectScenario = (productStoreLocation?: ProductStoreLocation) => {
  const productStore = productStoreLocation ? useProductStore(productStoreLocation) : undefined
  const leadTimes = useCollectLeadTimes()

  const collectView = () =>
    collectViewFromPdp({
      isEngraved: !!productStore?.isEngraved,
      isSpecialOrderProduct: !!productStore?.selectedProduct?.c_mhj_isSpecialOrderProduct,
      selectedSizeIsSpecialOrder: !!productStore?.selectedProcessedSizeOptions?.isSpecialOrder,
      resizeAvailable: !!productStore?.selectedProcessedSizeOptions?.resizeAvailable,
      sizeInStock: !!productStore?.selectedProcessedSizeOptions?.inStock,
      availableForClickAndCollect: !!productStore?.selectedProduct?.c_availableForClickAndCollect,
    })

  const storefrontInStock = () =>
    productStore?.selectedProcessedSizeOptions
      ? !!productStore.selectedProcessedSizeOptions.inStock
      : !!(productStore?.productAvailabilityModel?.isInStock || productStore?.productAvailabilityModel?.isLowStock)

  const resolveScenario = (stockLine?: Pick<StockResultStock, 'quantity' | 'source'>): CollectScenario =>
    resolveCollectScenario(collectView(), {
      storefrontInStock: storefrontInStock(),
      stockLine,
      leadTimes: leadTimes(),
      specialOrderLeadTime: productStore?.selectedProduct?.c_specialOrderLeadTime ?? 0,
    })

  return { collectView, resolveScenario }
}
